module.exports = __webpack_public_path__ + "static/img/Patient-Reg-Portal-2-600x431.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Patient-Reg-Portal-2-600x431.jpg
// module id = 2isR
// module chunks = 0